export default __webpack_public_path__ + "static/media/PenWriting.a948dde3.webm";